import React, { useContext } from 'react'
import { CustomLink } from '~/components/common/CustomLink'
import Dropdown from '~/components/common/Dropdown'
import { OpenClient } from '~/components/common/OpenInAgent'
import Tooltip from '~/components/common/Tooltip'
import { ChatContext } from '~/service/chatConn'
import { MiddlewareCommand } from '~/service/chatConn/types'
import { IframeContext } from '~/service/IframeConn'
import { VideoContext } from '~/service/videoConn'

type HeaderProps = {
  setSideActive: React.Dispatch<React.SetStateAction<boolean>>
  selectMiddlewareCommand: React.Dispatch<
    React.SetStateAction<MiddlewareCommand | undefined>
  >
}

const Header: React.FC<HeaderProps> = ({
  setSideActive,
  selectMiddlewareCommand,
}) => {
  const {
    activeChat: chat,
    activateChat,
    endChat,
    createTicket,
    middlewareCommands,
  } = useContext(ChatContext)

  const { createRoom } = useContext(VideoContext)

  return (
    <div className="chat-activeChat-header">
      <button
        onClick={() => {
          activateChat()
        }}
        className="chat-activeChat-header-back"
      >
        <span className="far fa-chevron-left" />
      </button>

      <figure className="chat-activeChat-header-avatar">
        <img src={chat.client.avatar} />
      </figure>

      <div className="chat-activeChat-header-name">
        <OpenClient client={chat.client}>{chat.client.name}</OpenClient>
      </div>

      <div className="chat-activeChat-header-buttons">
        {chat.links.map((el, k) =>
          el.type == 'link' ? (
            <CustomLink link={el} className="button is-white" key={k} />
          ) : (
            <Dropdown
              key={k}
              right={true}
              trigger={
                <button className="button is-white">
                  <span className="icon is-small">
                    <span className={'far fa-' + el.icon} />
                  </span>
                  <span>{el.name}</span>
                  <span className="icon is-small">
                    <span className="far fa-chevron-down" />
                  </span>
                </button>
              }
            >
              {el.links.map((link, k) => (
                <CustomLink
                  link={link}
                  className="dropdown-item has-icon"
                  key={k}
                />
              ))}
            </Dropdown>
          )
        )}

        <button
          className="button is-white is-side"
          onClick={() => setSideActive(v => !v)}
        >
          <span className="icon is-small">
            <span className="far fa-circle-info" />
          </span>
        </button>

        {window.c.janus && (
          <Tooltip
            content={intl.formatMessage({
              id: 'chat / header / video',
            })}
          >
            <button className="button is-white" onClick={createRoom}>
              <span className="icon is-small">
                <span className="far fa-video" />
              </span>
            </button>
          </Tooltip>
        )}

        <Dropdown
          right={true}
          trigger={
            <button className="button is-white">
              <span className="icon is-small">
                <span className="fa fa-ellipsis-vertical" />
              </span>
            </button>
          }
        >
          {!chat.stopped && (
            <a className="dropdown-item has-icon" onClick={endChat}>
              <span className="far fa-circle-xmark" />
              <div>
                {intl.formatMessage({
                  id: 'chat / header / dropdown / end chat',
                })}
              </div>
            </a>
          )}

          <a className="dropdown-item has-icon" onClick={createTicket}>
            <span className="far fa-plus" />
            <div>
              {intl.formatMessage({
                id: 'chat / header / dropdown / create ticket',
              })}
            </div>
          </a>

          {middlewareCommands.map((el, k) => (
            <a
              className="dropdown-item has-icon"
              onClick={() => selectMiddlewareCommand(el)}
              key={k}
            >
              <span className="far fa-square-terminal" />
              <div>{el.description}</div>
            </a>
          ))}
        </Dropdown>
      </div>
    </div>
  )
}

export default Header
